import type * as AddFreeShippingOffer from '@ori-events/add-free-shipping-offer';
import * as AddFreeShippingOfferFailed from '@ori-events/add-free-shipping-offer-failed';
import type { PositionData } from '@ori/analytics-data';

import { convertToCamelCase, getHttpRequestSettings } from '~/helpers';
import { RequestMethod, RequestUrl } from '~/models';

type Data = AddFreeShippingOffer.Data & PositionData;

export const dispatchAddFreeShippingOfferFailedEvent = (
  detail: AddFreeShippingOfferFailed.Data,
) => {
  const event = new CustomEvent<AddFreeShippingOfferFailed.Data>(AddFreeShippingOfferFailed.Name, {
    detail,
  });
  window.dispatchEvent(event);
};

export const addFreeShippingOfferHandler = async ({
  detail: { itemCode, placement },
}: CustomEvent<Data>) => {
  const request = await fetch(
    RequestUrl.AddFreeShippingOffer,
    getHttpRequestSettings({ itemCode, placement }, RequestMethod.Post),
  );

  const response = convertToCamelCase<AddFreeShippingOfferFailed.AddFreeShippingOfferResponse>(
    (await request.json()) as object,
  );
  if (AddFreeShippingOfferFailed.isAddFreeShippingOfferErrorResponse(response)) {
    dispatchAddFreeShippingOfferFailedEvent(response);

    return false;
  }

  return response;
};

export default addFreeShippingOfferHandler;
